import React from 'react';
import { PlusSquare } from 'lucide-react';

const ResetModal = ({ setShowResetConfirm, handleReset }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm">
    <div className="bg-slate-900 border border-slate-800 p-8 rounded-3xl shadow-2xl max-w-sm w-full text-center space-y-6 animate-in zoom-in-95">
      <PlusSquare className="w-12 h-12 text-emerald-500 mx-auto" />
      <h3 className="text-xl font-bold">Criar Novo Torneio?</h3>
      <p className='text-slate-400'>O torneio atual será arquivado e um novo será iniciado.</p>
      <div className="flex gap-3">
        <button onClick={() => setShowResetConfirm(false)} className="flex-1 py-3 rounded-2xl border border-slate-700 text-slate-400 font-bold">Cancelar</button>
        <button onClick={handleReset} className="flex-1 py-3 rounded-2xl bg-emerald-500 text-slate-950 font-black">Criar</button>
      </div>
    </div>
  </div>
);

export default ResetModal;
